


import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchProducts, deleteProduct } from '../redux/actions/productActions';
import { MdDelete, MdEdit } from 'react-icons/md';
import AddProductModal from '../components/Product/AddProductModal';
import ProductEditModal from '../components/Product/EditProduct';
import Loader from '../components/shared/Loader';
import ConfirmationModal from '../components/shared/productDeletedmodal';

const ProductList = () => {
  const dispatch = useDispatch();
  const { products, loading, error, pagination } = useSelector((state) => state.product);

  const [currentPage, setCurrentPage] = useState(1);
  const [productsPerPage] = useState(10);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isConfirmationModalOpen, setConfirmationModalOpen] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [productToEdit, setProductToEdit] = useState(null);

  const toggleModal = () => setModalOpen(!isModalOpen);

  useEffect(() => {
    dispatch(fetchProducts(currentPage, productsPerPage));
  }, [dispatch, currentPage, productsPerPage]);

  const totalPages = pagination?.totalPages || 0;

  const handleDelete = (productId) => {
    dispatch(deleteProduct(productId));
    setConfirmationModalOpen(false);
    dispatch(fetchProducts(currentPage, productsPerPage));
  };

  const handleNext = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevious = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const renderColors = (colors) => {
    if (!colors || colors.length === 0) return 'N/A';
    return (
      <div className="flex space-x-2">
        {colors.map((color, index) => (
          <div
            key={index}
            style={{ backgroundColor: color }}
            className="w-6 h-6 rounded-full border"
          />
        ))}
      </div>
    );
  };

  const handleToggle = (productId, currentStatus) => {
    console.log(`Toggling isActive for product ID ${productId}, New Status: ${!currentStatus}`);
  };

  const handleOpenConfirmationModal = (product) => {
    setProductToDelete(product);
    setConfirmationModalOpen(true);
  };

  const handleOpenEditModal = (product) => {
    setProductToEdit(product);
    setIsEditModalOpen(true);
  };

  const handleSaveProduct = (editedProduct) => {
    console.log('Saving product', editedProduct);
    dispatch(fetchProducts(currentPage, productsPerPage));
  };

  return (
    <div className="w-full h-auto bg-gray-100 p-4">
      
     
<div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-6">
  <h1 className="text-2xl font-bold text-gray-900 mb-4 sm:mb-0">Products Management</h1>
  <button
    onClick={toggleModal}
    className="bg-black text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition duration-200"
  >
    Add Product
  </button>
</div>


      {isModalOpen && (
        <AddProductModal isOpen={isModalOpen} toggleModal={toggleModal} />
      )}

      {isEditModalOpen && (
        <ProductEditModal
          isOpen={isEditModalOpen}
          toggleModal={() => setIsEditModalOpen(false)}
          product={productToEdit}
          onSave={handleSaveProduct}
        />
      )}

      {loading ? (
        <Loader />
      ) : error ? (
        <p className="text-red-500 text-center">{error}</p>
      ) : products && products.length > 0 ? (
        <>
          <div className="overflow-x-auto bg-white rounded-lg shadow-lg">
            <table className="min-w-full">
              <thead className="bg-black text-white">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Product Name</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Description</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Size</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Color</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Stock</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Category</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Primary Image</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Discount Price</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Active</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                </tr>
              </thead>
              <tbody>
                {products.map((item, index) => (
                  <tr
                    key={index}
                    className="border-b border-gray-200 hover:bg-gray-50 transition duration-300"
                  >
                    <td className="px-4 py-2">{item.name}</td>
                    <td className="px-4 py-2">{item.description}</td>
                    <td className="px-4 py-2">{item.price}</td>
                    <td className="px-4 py-2">{item.size?.join(', ') || 'N/A'}</td>
                    <td className="px-4 py-2">{renderColors(item.color)}</td>
                    <td className="px-4 py-2">{item.stock}</td>
                    <td className="px-4 py-2">{item.category}</td>
                    <td className="px-4 py-2">
                      <img
                        src={item.primaryImage}
                        alt={item.name}
                        className="w-20 h-20 object-cover rounded-md"
                      />
                    </td>
                    <td className="px-4 py-2">{item.discountPrice || 'N/A'}</td>
                    <td className="px-4 py-2">
                      <button
                        onClick={() => handleToggle(item._id, item.isActive)}
                        className={`text-${item.isActive ? 'green' : 'red'}-500 hover:text-${item.isActive ? 'green' : 'red'}-700`}
                      >
                        {item.isActive ? 'Activate' : 'Deactivate'}
                      </button>
                    </td>
                    <td className="px-4 py-2 flex justify-center items-center gap-2 relative top-6">
                      <MdEdit
                        className="text-2xl text-gray-500 cursor-pointer hover:text-gray-700"
                        onClick={() => handleOpenEditModal(item)}
                      />
                      <MdDelete
                        className="text-2xl text-red-400 cursor-pointer hover:text-red-600"
                        onClick={() => handleOpenConfirmationModal(item)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="flex justify-between items-center mt-4">
            <button
              onClick={handlePrevious}
              disabled={currentPage === 1}
              className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 disabled:opacity-50 transition duration-300"
            >
              Previous
            </button>
            <p className="text-gray-700">
              Page {currentPage} of {totalPages}
            </p>
            <button
              onClick={handleNext}
              disabled={currentPage === totalPages}
              className="px-4 py-2 bg-gray-300 rounded-lg hover:bg-gray-400 disabled:opacity-50 transition duration-300"
            >
              Next
            </button>
          </div>
          
        </>
      ) : (
        <p className="text-center text-gray-700">No products found.</p>
      )}

      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onClose={() => setConfirmationModalOpen(false)}
        onConfirm={() => productToDelete && handleDelete(productToDelete._id)}
        productName={productToDelete?.name}
      />
    </div>
  );
};

export default ProductList;